module.exports = __webpack_public_path__ + "static/media/kc5.167f6144.png";